window.getCities = function (province_id,city_id,city_name) {
  $("#cities").empty();
  try {
      $('#overlay').show();
      $('#loader').show();
      $.ajax({
          url : '/get-cities-list/'+province_id,
          type:'get',
          dataType: 'json',
          success: function(response) {
              $("#provinces").val(province_id).attr("selected","selected");
              $("#cities").append('<option value="">SELECT CITY</option>');
              response.forEach(function(city) {
                if(city_id == city.city_id)
                {
                  $("#cities").append('<option value=' + city.city_id + ' selected>' + city.name + '</option>');
                }
                if(city_name == city.name)
                {
                  $("#cities").append('<option value=' + city.city_id + ' selected>' + city.name + '</option>');
                }
                else {
                  $("#cities").append('<option value=' + city.city_id + '>' + city.name + '</option>');
                }
              });
           }
      });
     $('#overlay').hide();
     $('#loader').hide();
   } catch (err) {
     $("input[name='cities[]']").val('');
     $("#cities").hide();
     $('#overlay').hide();
     $('#loader').hide();
   }
}
